import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

// Real login for IDR.ExternalApp through ForthrightIdentityBroker.
// TODO: confirm the broker-registered clientId and API scope names.
// Expected shape, modeled after TheDesk:
// - clientId: idrportalapp
// - API scope: idrportalapp-api
// - broker scope: identitybroker-api
export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.brokerAuthority,
    redirectUrl: `${window.location.origin}/auth-callback`,
    postLogoutRedirectUri: window.location.origin,
    clientId: 'idrportalapp',
    scope: 'openid profile idrportalapp-api identitybroker-api',
    responseType: 'code',
    triggerAuthorizationResultEvent: true,
    secureRoutes: [environment.apiUrl, environment.brokerAuthority],
    autoUserInfo: false,
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    useRefreshToken: false,
    logLevel: LogLevel.Warn,
  },
};
